import { ZViewIdInput } from "./viewId.schema";
import { z } from "zod";
import { ZMultiplacerModuleKey, ZProjectNo } from "./foundationSchema";
import { ZViewPresetMongoDocument, ZViewPresetScope } from "./mongodocuments/viewMongoDocument.schema";
const ZViewPresetDefinition = ZViewPresetMongoDocument.pick({
    name: true,
    description: true,
    view: true,
});
/** Built-in presets have a stable code-defined key and need no database metadata. */
export const ZBuiltInViewPreset = ZViewPresetDefinition.extend({
    // A built-in display configuration can be offered in several modules.
    modules: z.array(ZMultiplacerModuleKey).min(1),
    source: z.literal("builtIn"),
    key: z.string().min(1),
});
export const ZViewPreset = z.discriminatedUnion("source", [
    ZBuiltInViewPreset,
    ZViewPresetMongoDocument,
]);
// The server supplies identity, kind, source and audit metadata.
export const ZCreateViewPresetInput = ZViewPresetMongoDocument.pick({
    name: true,
    description: true,
    view: true,
    projectNo: true,
    scope: true,
});
export const ZListViewPresetsInput = z.object({
    projectNo: ZProjectNo,
    scope: ZViewPresetScope.optional(),
});
// Scope and ownership are fixed at creation. Save a new preset to share a personal view.
export const ZUpdateViewPresetInput = ZViewIdInput.extend({
    changes: ZViewPresetDefinition.partial(),
});
